"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingItemTableFooter = void 0;
const addDays_1 = __importDefault(require("date-fns/addDays"));
const startOfToday_1 = __importDefault(require("date-fns/startOfToday"));
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const BookingDiscount_1 = require("../../models/BookingDiscount");
const InvoiceStatus_1 = require("../../models/InvoiceStatus");
const Payment_1 = require("../../models/Payment");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const AddonDropdown_1 = require("../addon-dropdown/AddonDropdown");
const DayPickerModal_1 = require("../day-picker/DayPickerModal");
const IconDiscount_1 = require("../icons/IconDiscount");
const IconMoneyOff_1 = require("../icons/IconMoneyOff");
const IconPayment_1 = require("../icons/IconPayment");
const IconToday_1 = require("../icons/IconToday");
require("./BookingItemTableFooter.scss");
const BookingTotalsTable_1 = require("./BookingTotalsTable");
const BookingItemTableFooter = (props) => {
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    const hasDiscount = props.booking.discount !== undefined;
    function handleAddTotalDiscount() {
        if (!hasDiscount) {
            const newDiscount = new BookingDiscount_1.BookingDiscount();
            newDiscount.percent = 0;
            props.onBookingChange({ discount: newDiscount });
        }
    }
    function handleAddPayment() {
        // Add payment by default with current balance.
        const newPayment = new Payment_1.Payment((0, startOfToday_1.default)(), props.booking.calcTotals().outstandingBalance);
        props.onBookingChange({
            payments: [...props.booking.payments, newPayment],
        });
    }
    function handleSetInvoiceDate() {
        showModal(react_1.default.createElement(DayPickerModal_1.DayPickerModal, { title: "Rechnungsdatum", date: props.booking.invoiceDate, onDateSelect: (invoiceDate) => {
                let dueDate;
                if (invoiceDate) {
                    dueDate = (0, addDays_1.default)(invoiceDate, 10);
                }
                else {
                    dueDate = undefined;
                }
                props.onBookingChange({ invoiceDate, dueDate });
                hideModal();
            }, onClose: hideModal, minDate: dateUtils.defaultMinDate, maxDate: dateUtils.defaultMaxDate }));
    }
    function handleVoidInvoice() {
        props.onBookingChange({ invoiceStatus: InvoiceStatus_1.InvoiceStatus.void });
    }
    return (react_1.default.createElement(Card_1.default.Footer, { className: "booking-item-table-footer" },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-sm-5 col-md-4 item-table-buttons" }, props.editable && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(AddonDropdown_1.AddonDropdown, { className: "no-print", booking: props.booking, onNewAddon: props.onNewAddon }),
                react_1.default.createElement(Button_1.default, { className: "no-print", variant: "light", size: "sm", onClick: handleAddTotalDiscount, disabled: hasDiscount },
                    react_1.default.createElement(IconDiscount_1.IconDiscount, null),
                    " Gesamtrabatt hinzuf\u00FCgen"),
                react_1.default.createElement(Button_1.default, { className: "no-print", variant: "light", size: "sm", onClick: handleVoidInvoice, disabled: props.booking.hasVoidedInvoice() },
                    react_1.default.createElement(IconMoneyOff_1.IconMoneyOff, null),
                    " Rechnung stornieren"),
                react_1.default.createElement(Button_1.default, { className: "no-print", variant: "light", size: "sm", onClick: handleAddPayment },
                    react_1.default.createElement(IconPayment_1.IconPayment, null),
                    " Zahlung erfassen")))),
            react_1.default.createElement("div", { className: "col-sm-7 col-md-6 offset-md-2" },
                react_1.default.createElement(BookingTotalsTable_1.BookingTotalsTable, { booking: props.booking, onBookingChange: props.onBookingChange, editable: props.editable }),
                react_1.default.createElement("div", { className: "d-flex justify-content-end dates mt-3" },
                    react_1.default.createElement("div", { className: "date-btn" + (props.editable ? " editable" : ""), title: props.editable ? "Rechnungsdatum bearbeiten" : "", onClick: () => {
                            if (props.editable) {
                                handleSetInvoiceDate();
                            }
                        } },
                        react_1.default.createElement("dl", null,
                            react_1.default.createElement("dt", null, "Rechnung verschickt am"),
                            react_1.default.createElement("dd", { className: "mb-0 d-flex" },
                                react_1.default.createElement("div", { className: "flex-grow-1" }, props.booking.invoiceDate
                                    ? dateUtils.formatDate(props.booking.invoiceDate)
                                    : "---"),
                                props.editable && react_1.default.createElement(IconToday_1.IconToday, { className: "no-print" })))),
                    react_1.default.createElement("dl", { className: "ml-5" },
                        react_1.default.createElement("dt", null, "Zahlbar bis"),
                        react_1.default.createElement("dd", { className: "mb-0" }, props.booking.dueDate
                            ? dateUtils.formatDate(props.booking.dueDate)
                            : "---"))))),
        modal));
};
exports.BookingItemTableFooter = BookingItemTableFooter;
